export default __webpack_public_path__ + "static/media/ICON_Wallet.f6731d1d.svg";